import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UpperCasePipe, CommonModule } from '@angular/common';
import { NumberInputComponent } from '@navstation-portal/shared/ui/components';
import { FormsModule } from '@angular/forms';
import { OffshoreStockFormStore } from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-fuel-type-totals',
  templateUrl: './fuel-type-totals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, NumberInputComponent, UpperCasePipe],
})
export class FuelTypeTotalsComponent {
  stockStore = inject(OffshoreStockFormStore);
}
